import { i18n } from '@percent/hosted-validation-form/i18n/config';
import { ErrorCard, Layout, ErrorVariant } from '@percent/domain/verifications';

export const ErrorFallback = () => {
  const { t } = i18n;

  return (
    <Layout termsLabel={t('hostedValidation.footer.terms')} privacyLabel={t('hostedValidation.footer.privacy')}>
      <ErrorCard
        title={t('hostedValidation.errorMessage.somethingWentWrong')}
        subtitle={t('hostedValidation.errorMessage.reloadPage')}
        variant={ErrorVariant.INTERNAL}
      />
    </Layout>
  );
};
